import { getApiBaseUrl } from './utils/getHeaderData';
export const API_URL = getApiBaseUrl();
export const endpointTags = [
  'Interest',
  'User',
  'Category',
  'Insight',
  'Source',
  'UserSettings',
  'SourceData',
  'Synthesis',
  'Chat',
];
